import { BlockTitle } from "@blocks/Blocks";
import { useWindowSize } from "@hooks/useWindowSize";
import Embed from "@pages/Article/components/StoryElements/Embed";
import { useSendInViewGTM } from "@pages/SingaporeGe/2025/hooks/useSendInViewGTM";
import { getScreenIframeSize } from "@pages/SingaporeGe/2025/utils/helpers";
import { IframeEmbedProps } from "@pages/SingaporeGe/2025/utils/types";
import { Field } from "@typings/Cue";
import { Name } from "@typings/enums";
import { cn } from "@util/helpers";

export default function IframeEmbed({
  configData: data,
  index,
  gaObject,
  className,
}: IframeEmbedProps): React.ReactElement {
  const { isScreenLG, isScreenMD } = useWindowSize();

  const { ref: iframeRef } = useSendInViewGTM({
    eventsObject: gaObject?.eventObject,
  });

  if (!data) return <></>;

  const screenObj = getScreenIframeSize(data, isScreenLG, isScreenMD);

  const iframeAttributes = {
    className: cn("box-content w-full overflow-auto border-none"),
    src: data.src,
    ...screenObj,
  };

  const field: Field[] = [
    {
      name: Name.Uri,
      value: data.src,
      annotations: [],
    },
  ];

  return (
    <div
      data-testid="iframe-embed-component"
      className={className}
      ref={iframeRef}
    >
      {data.title ? (
        <BlockTitle text={data.title} rootClassName="mb-4" />
      ) : null}

      {screenObj.width === "100%" && screenObj.height === "100%" ? (
        <Embed fields={field} />
      ) : (
        <iframe
          {...iframeAttributes}
          id={`iframe-${index}`}
          title={data.title || `iframe-${index}`}
        />
      )}
    </div>
  );
}
